export default __webpack_public_path__ + "static/media/scott-graham-5fNmWej4tAA-unsplash.73ed7a78.webp";